import { render, staticRenderFns } from "./cvss.vue?vue&type=template&id=82ccede0"
import script from "./cvss.vue?vue&type=script&lang=js"
export * from "./cvss.vue?vue&type=script&lang=js"
import style0 from "./cvss.vue?vue&type=style&index=0&id=82ccede0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports